module.exports = __webpack_public_path__ + "img/technical.3fdb7e26.png";